function $54b47fc030b7b21e$export$2e2bcd8739ae039() {
    const message = prompt("Enter your message:");
    alert(message);
}
$54b47fc030b7b21e$export$2e2bcd8739ae039();




//# sourceMappingURL=parcel-task6.293f8aef.js.map
